import { SocialSectionDataProps } from 'mm-ui-components/dist/src/base/components/navigation/footer/AdditionalFooterSections/FooterSocialLinks';
import { NavigationLink } from 'mm-ui-components/dist/src/base/components/navigation/header/primaryHeader/PrimaryHeader';
import { LinkButtonDataProps } from 'mm-ui-components/dist/src/base/components/navigation/utils';
import { MenuLinkDataProps } from 'mm-ui-components/dist/src/base/components/navigation/header/primaryHeader/menu/links/MenuSubLink';
import { INJECT_BUTTON_TO_MENU, INJECT_VIDEO_LOGO, InjectVideoLogoParams } from '../primaryHeader/primaryHeader.actions';
import { LinkButton } from '../utils/navigation.utils';

type Link = {
    text: string;
    href: string;
};

export interface MenuLink extends Link {
    childrenLinks: Array<Link>;
}
interface Menu {
    links: Array<MenuLink>;
    buttons?: Array<LinkButton>;
}

interface MenuData {
    links: MenuLinkDataProps[];
    buttons?: Array<LinkButtonDataProps>;
}

export interface HeaderWithSubMenusState {
    logo: {
        svgLarge: string;
        svgSmall: string;
        svgLargeViewBox: string;
        svgSmallViewBox: string;
        alt: string;
        href: string;
    };
    logoImageLarge: string | null;
    logoImageSmall: string | null;
    links: NavigationLink[] | null;
    editions: NavigationLink[] | null;
    cta: Link | null;
    menu: MenuData | null;
    pagePath: string;
    editionEndpoint: string;
    videoLogo: InjectVideoLogoParams | null;
    socialSection: SocialSectionDataProps | null;
    moreButtonText: string;
}

export interface InjectVideoLogoAction {
    type: typeof INJECT_VIDEO_LOGO;
    videoPath: string;
}

export interface InjectButtonToMenuAction {
    type: typeof INJECT_BUTTON_TO_MENU;
    onClick: string;
    text: string;
}

export type HeaderWithSubMenusAction = InjectVideoLogoAction | InjectButtonToMenuAction;

export const headerWithSubMenusReducer = (state: HeaderWithSubMenusState = {} as HeaderWithSubMenusState, action: HeaderWithSubMenusAction) => {
    switch (action.type) {
        case INJECT_VIDEO_LOGO: {
            const { videoPath } = action;
            return {
                ...state,
                videoLogo: {
                    videoPath,
                },
            };
        }
        case INJECT_BUTTON_TO_MENU: {
            const { text, onClick } = action;
            const buttons = state.menu && state.menu.buttons;
            return {
                ...state,
                menu: {
                    ...state.menu,
                    buttons: [
                        ...(buttons || []),
                        {
                            text,
                            onClick,
                        },
                    ],
                },
            };
        }
        default:
            return state;
    }
};
